// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.horizontalLayout-module_horizontalLayout__bKZuL {
    display: flex;
    width: 100%;
    flex-direction: row;
    box-sizing: border-box;

    justify-content: center;
    align-items: start;
}

.horizontalLayout-module_alignment-end__JSvYs {
    align-items: end;
}

.horizontalLayout-module_alignment-center__N7rhO {
    align-items: center;
}

.horizontalLayout-module_arrangement-start__UD4zd {
    justify-content: flex-start;
}

.horizontalLayout-module_arrangement-end__HbTbC {
    justify-content: flex-end;
}

.horizontalLayout-module_arrangement-space-between__hDMZE {
    justify-content: space-between;
}

.horizontalLayout-module_arrangement-space-around__gPMEr {
    justify-content: space-around;
}`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/layout/css/horizontalLayout.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,sBAAsB;;IAEtB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":[".horizontalLayout {\n    display: flex;\n    width: 100%;\n    flex-direction: row;\n    box-sizing: border-box;\n\n    justify-content: center;\n    align-items: start;\n}\n\n.alignment-end {\n    align-items: end;\n}\n\n.alignment-center {\n    align-items: center;\n}\n\n.arrangement-start {\n    justify-content: flex-start;\n}\n\n.arrangement-end {\n    justify-content: flex-end;\n}\n\n.arrangement-space-between {\n    justify-content: space-between;\n}\n\n.arrangement-space-around {\n    justify-content: space-around;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"horizontalLayout": `horizontalLayout-module_horizontalLayout__bKZuL`,
	"alignment-end": `horizontalLayout-module_alignment-end__JSvYs`,
	"alignment-center": `horizontalLayout-module_alignment-center__N7rhO`,
	"arrangement-start": `horizontalLayout-module_arrangement-start__UD4zd`,
	"arrangement-end": `horizontalLayout-module_arrangement-end__HbTbC`,
	"arrangement-space-between": `horizontalLayout-module_arrangement-space-between__hDMZE`,
	"arrangement-space-around": `horizontalLayout-module_arrangement-space-around__gPMEr`
};
export default ___CSS_LOADER_EXPORT___;
